import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getChannelContentId = (channel: LegacyTvChannelPlayerBaseInfoContent) =>
    channel.channelContentId ?? '';
